import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs/internal/observable/throwError';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './Login.component.html'
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  constructor(private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
    private authenticationService: AuthenticationService,) {
    // if (this.authenticationService.currentUserValue) {
    //         this.router.navigate(['/']);
    // }
  }
  ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams[' returnUrl '] || '/';
  }
  get f() { return this.loginForm.controls; }
  onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .subscribe(
                () => {
                    // const id = this.authenticationService.currentUserValue.id;
                    // if (!isNaN(id) && id > 0 && id < 6 ) {
                      this.router
                        .navigate([
                          this.route.snapshot.queryParams[environment.baseUrl] ||
                            environment.baseUrl,
                        ])
                        // .then(() => {
                        //   window.location.reload();
                        // });
                      this.loading = false;
                    // } else {
                    //   this.error = 'login non andato a buon fine';
                    //   this.loading = false;
                    // }
                },
              error => {
                    this.errorHandl(error)
                    this.loading = false;
                });
    }
    errorHandl(error) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      this.error = errorMessage;
      console.log(errorMessage);
      return throwError(errorMessage);
    }
  showforgot() {
    this.router.navigate(["/Login/forgot"]);
  }
}
